import styled from 'styled-components';
import { SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';

export const Container = styled.div`
  position: relative;
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;

export const StyledPagination = styled.div<{ isListView: boolean; pictureLength?: number }>`
  display: flex;
  justify-content: ${(props): string => (props.isListView ? 'center' : 'flex-end')};
  ${(props): string =>
    props.pictureLength === undefined || props.pictureLength > 1
      ? `margin-top: ${SYS_SPACE_FIXED_100};`
      : `margin-top: 30px;`}
`;
